// components/ui/Content/ChartComponent1.tsx
'use client';

import {
  ChartContainer,
  ChartLegend,
  ChartTooltip,
  ChartTooltipContent
} from '@/components/ui/chart';

import ChartComponent from './ChartsComponet';
import { CartesianGrid, ComposedChart, Line, XAxis, YAxis } from 'recharts';

// components/ui/Content/ChartComponent1.tsx

export default function ChartComponent1() {
  const chartData1 = {
    title: 'Funding Trends in Bioeconomy Startups',
    source: 'Sources: Crunchbase, PitchBook, CB Insights'
  };

  const chartConfig = {
    Agritech: {
      label: 'Agritech',
      color: '#82e482'
    },
    Bioenergy: {
      label: 'Bioenergy',
      color: '#b580e4'
    },
    Biomaterials: {
      label: 'Biomaterials',
      color: '#80ace4'
    }
  };

  const data = [
    { year: '2013', agritech: 200, bioenergy: 100, biomaterials: 50 },
    { year: '2014', agritech: 300, bioenergy: 150, biomaterials: 80 },
    { year: '2015', agritech: 250, bioenergy: 120, biomaterials: 100 },
    { year: '2016', agritech: 400, bioenergy: 200, biomaterials: 150 },
    { year: '2017', agritech: 450, bioenergy: 250, biomaterials: 200 },
    { year: '2018', agritech: 500, bioenergy: 300, biomaterials: 250 },
    { year: '2019', agritech: 600, bioenergy: 350, biomaterials: 300 },
    { year: '2020', agritech: 700, bioenergy: 400, biomaterials: 350 },
    { year: '2021', agritech: 800, bioenergy: 450, biomaterials: 400 },
    { year: '2022', agritech: 900, bioenergy: 500, biomaterials: 450 },
    { year: '2023', agritech: 950, bioenergy: 550, biomaterials: 500 },
    { year: '2024', agritech: 1050, bioenergy: 600, biomaterials: 550 },
    { year: '2025', agritech: 1200, bioenergy: 700, biomaterials: 650 },
    { year: '2026', agritech: 1400, bioenergy: 850, biomaterials: 800 }
  ];

  // Create the chart as a React element
  const chart = (
    <ChartContainer config={chartConfig}>
      <ComposedChart
        data={data}
        margin={{
          top: 0,
          right: 2,
          bottom: 0,
          left: 0
        }}>
        <CartesianGrid strokeDasharray='3 3' />
        <XAxis
          dataKey='year'
          tickLine={false}
        />
        <YAxis />
        <ChartTooltip content={(props) => <ChartTooltipContent {...props} />} />
        <ChartLegend verticalAlign='top' />
        <Line
          type='linear'
          dataKey='agritech'
          stroke={chartConfig.Agritech.color}
          name={chartConfig.Agritech.label}
          strokeWidth={3}
          isAnimationActive={true}
        />
        <Line
          type='linear'
          dataKey='bioenergy'
          stroke={chartConfig.Bioenergy.color}
          name={chartConfig.Bioenergy.label}
          strokeWidth={3}
          isAnimationActive={true}
        />
        <Line
          type='linear'
          dataKey='biomaterials'
          stroke={chartConfig.Biomaterials.color}
          name={chartConfig.Biomaterials.label}
          strokeWidth={3}
          isAnimationActive={true}
        />
      </ComposedChart>
    </ChartContainer>
  );

  return (
    <ChartComponent
      data={chartData1} // Pass the data with title and source
      chart={chart} // Pass the chart as a React element
    />
  );
}
